import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, spacing, breakpoints } = redesignTheme;

export const useNeedsContentStyles = makeStyles(() => ({
  summary: {
    marginBottom: spacing.lg,
  },
  pyramids: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: spacing.lg,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: spacing.xl,
    },
  },
  pyramidColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    lineHeight: '22px',
  },
  pyramid: {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
  favorite: {
    color: colors.primaryDark,
  },
  application: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    lineHeight: '22px',
  },
}));
